import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "./PageTransition";
import CrossSellSimple from "@/pages/CrossSellSimple";
import ResetPassword from "@/pages/ResetPassword";
import SocialTemplates from "@/pages/SocialTemplates";
import Index from "@/pages/Index";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Index /></PageTransition>} />
        <Route path="/index" element={<Navigate to="/" replace />} />
        <Route path="/cross-sell-simple" element={<PageTransition><CrossSellSimple /></PageTransition>} />
        <Route path="/cross-sell-calculator" element={<Navigate to="/cross-sell-simple" replace />} />
        <Route path="/social-templates" element={<PageTransition><SocialTemplates /></PageTransition>} />
        <Route path="/reset-password" element={<PageTransition><ResetPassword /></PageTransition>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
